// krida-ui-error.js - Error Modal handling

export function showErrorModal(title, message) {
  console.error(`KridaUIErrorModal: Title: ${title}, Message: ${message}`);

  // Remove existing error modal first
  const existingModal = document.getElementById('error-modal');
  if (existingModal) {
    existingModal.remove();
  }

  // Create modal elements
  const modal = document.createElement('div');
  modal.id = 'error-modal';
  modal.className = 'modal error-modal';
  modal.style.display = 'flex'; // Use flex for potential centering via CSS

  const modalContent = document.createElement('div');
  modalContent.className = 'modal-content';

  const modalHeader = document.createElement('div');
  modalHeader.className = 'modal-header error-header';
  const modalTitle = document.createElement('div');
  modalTitle.className = 'modal-title';
  modalTitle.innerHTML = title || 'Error';
  modalHeader.appendChild(modalTitle);

  const modalBody = document.createElement('div');
  modalBody.className = 'modal-body';
  modalBody.innerHTML = message || 'An unknown error occurred.';

  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'modal-buttons';
  const closeButton = document.createElement('button');
  closeButton.textContent = 'Close';
  closeButton.className = 'modal-button close-button';
  closeButton.addEventListener('click', () => {
    modal.remove();
  });
  buttonContainer.appendChild(closeButton);

  // Assemble and display
  modalContent.appendChild(modalHeader);
  modalContent.appendChild(modalBody);
  modalContent.appendChild(buttonContainer);
  modal.appendChild(modalContent);
  document.body.appendChild(modal);

  modal.style.display = 'block'; // Or 'flex'
} 